import { render, staticRenderFns } from "./BInputCPF.vue?vue&type=template&id=500df666&"
import script from "./BInputCPF.vue?vue&type=script&lang=js&"
export * from "./BInputCPF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports